import React from 'react';
import JobsFormContainer from '../../../../Containers/AdminContainer/Jobs/JobsForm';

const JobsFormScreen = () => {
  return <JobsFormContainer />;
};

export default JobsFormScreen;
